// pages/Dashboard.jsx
import UpcomingPlans from "../../components/home/subscriptionComponents/UpcomingPlans";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <UpcomingPlans />
    </HomeLayout>
  );
}
